module.exports = __webpack_public_path__ + "img/wordmark.8ce0cf67.png";